import { render } from "./QuestionnairePage.vue?vue&type=template&id=110be962&scoped=true"
import script from "./QuestionnairePage.vue?vue&type=script&lang=js"
export * from "./QuestionnairePage.vue?vue&type=script&lang=js"

import "./QuestionnairePage.vue?vue&type=style&index=0&id=110be962&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-110be962"]])

export default __exports__